import { Loader2, CheckCircle2, Globe, Search, FileText, TrendingUp, Sparkles } from "lucide-react";

const STAGES = [
  { icon: Globe,      label: "Fetching your website" },
  { icon: Search,     label: "Reading headlines, offers and CTAs" },
  { icon: FileText,   label: "Inferring audience, USP and competitors" },
  { icon: TrendingUp, label: "Building growth score & today's actions" },
  { icon: Sparkles,   label: "Writing ad copy, keywords and 30-day calendar" },
];

export default function ProgressPanel({ stage, url }) {
  const host = url ? url.replace(/^https?:\/\//, "").split("/")[0] : "your site";
  return (
    <div className="fade-up" data-testid="generating-panel">
      <span className="chip"><span className="h-1.5 w-1.5 rounded-full bg-indigo-600 animate-pulse" /> Working on it</span>
      <h1 className="font-display font-black text-4xl md:text-5xl tracking-tight text-zinc-900 mt-6">
        Building your plan for {host}…
      </h1>
      <p className="text-zinc-600 mt-3">This usually takes 60-120 seconds. Don't close this tab.</p>

      <div className="mt-10 bg-white border border-zinc-200 rounded-2xl p-8 space-y-4">
        {STAGES.map((s, i) => {
          const done = i < stage;
          const active = i === stage;
          return (
            <div
              key={`stage-${s.label}`}
              data-testid={`stage-${i}`}
              className={`flex items-center gap-3 p-3 rounded-xl border ${
                done ? "border-emerald-200 bg-emerald-50/50" :
                active ? "border-indigo-200 bg-indigo-50/50" : "border-zinc-100 bg-white"
              }`}
            >
              <div className={`h-9 w-9 rounded-lg flex items-center justify-center ${
                done ? "bg-emerald-500 text-white" :
                active ? "bg-indigo-600 text-white" : "bg-zinc-100 text-zinc-400"
              }`}>
                {done ? <CheckCircle2 className="h-5 w-5" /> :
                 active ? <Loader2 className="h-5 w-5 animate-spin" /> :
                 <s.icon className="h-5 w-5" />}
              </div>
              <div className={`text-sm ${done ? "text-emerald-800 line-through" : active ? "font-medium text-zinc-900" : "text-zinc-500"}`}>
                {s.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// Export stage count so callers can drive the progress timer safely.
export const STAGE_COUNT = STAGES.length;
